import type { FaireProductEntity } from "../../entity_types/product";

export const p_gqfz4dmrjt: FaireProductEntity = {
  token: "p_gqfz4dmrjt",
  type: "product",
  name: "Easily Distracted By Birds Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/15438a83335460aa45982b86188019201590b88b058d2dbf8f07b4322447d83d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/02b83bfb4d2ec29d06ab29b06c84b3a6fd83f5307d056d51a2d3ef4ef0d19507.jpeg",
    "https://cdn.faire.com/fastly/424c52e5d3961a47baa802c1618636d6e5c7774f8cc9f062f9db835eb1d7c0b8.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/5c96e84d643fa070b836a54e588bef1603f6b0f1b87bbb89420021e9938ab48b.jpeg",
    "https://cdn.faire.com/fastly/0506eee68bda3a49308fd91609b2d950c00ff1c849cfa88ba591fd1aa38200f1.jpeg"
  ],
  priceDollars: 6.75,
  description: "Let's face it. Birds are crazy (and not real). Rock hard noses that are also mouths... forks for feet... and they fly? No wonder you're distracted. Let these socks keep you grounded. 🐦\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:09.270Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
